import { defineMessages } from 'react-intl';

export default defineMessages({
    changeButton: {
        id: 'twia.gateway.contacts.renewal.Change',
        defaultMessage: 'Change',
    },
    cancelButton: {
        id: 'twia.gateway.contacts.renewal.Cancel',
        defaultMessage: 'Cancel',
    },
    required: {
        id: 'twia.gateway.contacts.renewal.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
})